import {authorize} from "@athena-portal/components";
import * as React from "react";
import {ImgTileLink} from "../../../../components/ImgTileLink";
import {resourcesHelper,
    ICustomerPortalService,
    Types
} from "@falcon/services";
import {RouteComponentProps} from "react-router-dom";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {lazyInject} from "@athena-portal/core";

interface IPolicySummaryPageParams {

}

interface IPolicySummaryPageProps extends RouteComponentProps<IPolicySummaryPageParams> {
    location: any;
}

interface IState {
    name?: string;
}

@authorize
export class AllianzAdvantagePage extends React.Component<IPolicySummaryPageProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IPolicySummaryPageProps) {
        super(props);

        this.state = {
            name: ""
        }
    }

    public componentDidMount() {
        this.customerPortalService.getProfile().subscribe(party => {
            const name = party?.firstName;
            this.setState({name});
        })

        window.scrollTo(0, 0);
    }

    public render() {
        return (<>
            <FalconHeader/>

            {this.renderMainImage()}
            {this.renderMainImageFooter()}

            <div className={`advantage-tiles-background`}>
                <div className="advantage-tiles-background dashboard-page pt-3">
                    {this.renderTilesHeader()}
                    {this.renderTiles()}
                </div>
            </div>
            {this.renderLatestNews()}
            <FalconFooter/>
        </>)
    }

    private renderTiles(): React.JSX.Element {
        return (<div className="link-grid ">
            <div className="d-flex flex-wrap flexItemAdvantage">
                <div className="flexItem advantageItem advantages-stadium">
                    <ImgTileLink id="advantages-stadium"
                                 src={`/${resourcesHelper.THEME}/img/advantage-stadium.svg`}
                                 alt="Allianz stadium rewards"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/allianz-stadium-rewards.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        Allianz stadium rewards
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem quotes">
                    <ImgTileLink id="quotes"
                                 src={`/${resourcesHelper.THEME}/img/savings_icon.png`}
                                 alt="Save with Allianz"
                                 to="https://allianz-advantages.memberrewards.uk/a_"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        Save with Allianz
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem savings">
                    <ImgTileLink id="savings"
                                 src={`/${resourcesHelper.THEME}/img/gift_icon.svg`}
                                 alt="Win with Allianz"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/win-with-allianz.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        Win with Allianz
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem advantages-hands-stars">
                    <ImgTileLink id="advantages-hands-stars"
                                 src={`/${resourcesHelper.THEME}/img/advantage-hands-stars.svg`}
                                 alt="The Allianz difference"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/allianz-difference.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        The Allianz difference
                    </ImgTileLink>
                </div>
            </div>
        </div>)

    }


    private renderMainImage() {
        return (
            <div className={`advantage-background`}>
                <div className={`page-contents dashboard-page pt-3 pr-5`}>
                    <div className={`mt-3 mb-3`}>
                        <a className={`advantages-white-link mt-3`} href={`/dashboard`}>
                            <img src={`/${resourcesHelper.THEME}/img/back-arrow-white.svg`} className={`mr-1`} alt={`Back to dashboard`}/>
                            <u> Back to dashboard</u></a>
                    </div>
                    <div>
                        <div>
                            <img className={`advantage-rugby-image`}
                                 src={`/${resourcesHelper.THEME}/img/rugby.png`} alt={`Allianz Advantages`}/>
                        </div>
                        <div className={`advantage-text-block`}>
                            <img className={`allianz-advantages-img`} src={`/${resourcesHelper.THEME}/img/allianz-advantages-logo.svg`}  alt={`Allianz advantages`}/>
                            <p className={`font-weight-bold mt-1`}>Thank you for being an Allianz customer, {this.state?.name}.
                                Welcome to Allianz Advantages, where you’ll find...</p>
                            <ul className="info-modal-bullet-points"
                                style={{listStyleImage: "url('/img/ul_check.svg')"}}>
                                <li key={`info-modal-1`} className="mb-2">
                                    Offers and discounts just for you.
                                </li>
                                <li key={`info-modal-2`} className="mb-2">
                                    Your chance to win fantastic prizes.
                                </li>
                                <li key={`info-modal-3`} className="mb-2">
                                    Exclusive rewards and giveaways for our rugby fans, including tickets to Allianz Stadium – the Home of England Rugby.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    private renderMainImageFooter() {
        return (
            <div className={`advantage-main-image-footer-background`}>
                <div className={`advantage-main-image-footer-content`}>
                    <div className={`d-inline-block advantage-main-image-footer-gift-background`}>
                        <img className={`advantage-main-image-footer-gift`}
                            src={`/${resourcesHelper.THEME}/img/gift-white.svg`}  alt={`Allianz advantages`}/>
                    </div>
                    <div className={`advantages-footer-helper`}>
                        <h1 className={`advantages-main-image-footer-title`}>What's new</h1>
                        <p className={`advantages-main-image-footer-text`}>Get 10% off solar panels from Effective Homes
                            - helping you save money sustainably</p>
                        <a className={`advantages-white-link`} href={`https://www.allianz.co.uk/insurance/customer-offers/effective-home.html`}><u>View this offer </u>
                            <img className={`mr-1`} src={`/${resourcesHelper.THEME}/img/arrow-right-white.svg`}  alt={`View this offer`}/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }

    private renderTilesHeader() {
        return (<h1 className={`advantage-tile-header mb-2 mt-4`}>Your Allianz Advantages...</h1>)
    }

    private renderLatestNews() {
        return (<div className={`dashboard-page mt-5`}>
            <img
                src={`/${resourcesHelper.THEME}/img/envelop.svg`}  alt={`Latest offer`}/>
            <h1 className={`advantage-tile-header mb-1 mt2`}>Want to hear about our latest offers?</h1>
            <p>Make sure you sign up to our marketing communications to receive notifications of new offers and rewards.</p>
            <a className={`font-weight-bold`} href={`/dashboard/marketing-preferences`}><u>My marketing preferences</u> <img
                className={`ml-1`} src={`/img/arrow-right.svg`} alt={`Allianz Advantages`}/>
            </a>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/advantages/AllianzAdvantagePage.tsx